/*import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc, setDoc, increment } from 'firebase/firestore';
import { db, auth } from './firebase';
import { useStateValue } from './StateProvider';
import './ProductDetails.css';
import { toast } from 'react-toastify';

function ProductDetails() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [, dispatch] = useStateValue();

  useEffect(() => {
    const fetchProduct = async () => {
      const docRef = doc(db, 'prodotti', id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = { id: docSnap.id, ...docSnap.data() };
        setProduct(data);

        // Imposta la prima variante come predefinita
        if (data.variants && data.variants.length > 0) {
          setSelectedVariant(data.variants[0]);
        } else {
          setSelectedVariant(null);
        }

        setCurrentImageIndex(0);
      }
    };

    fetchProduct();
  }, [id]);

  const addToBasket = async () => {
    if (Array.isArray(product.variants) && product.variants.length > 0 && !selectedVariant) {
        alert("Seleziona una misura prima di aggiungere al carrello");
        return;
    }

    const finalID = selectedVariant ? selectedVariant.originalID : product.id;
    const finalSize = selectedVariant?.size ?? null;
    const finalPrice = Number(selectedVariant?.price ?? product.price);
    const finalPeso = selectedVariant?.peso ?? product.peso;
    const finalImage = selectedVariant?.image || product.image;

    const itemToAdd = {
        id: product.id,
        originalID: finalID,
        title: product.title,
        description: product.description,
        image: finalImage,
        price: finalPrice,
        quantity: Number(quantity) || 1,
        peso: finalPeso,
        size: finalSize
    };

    const user = auth.currentUser;
    const itemKey = `${finalID}_${finalSize}`;

    if (user) {
        const cartItemRef = doc(db, "users", user.uid, "carrello", itemKey);
        try {
            await setDoc(cartItemRef, {
                ...itemToAdd,
                quantity: increment(itemToAdd.quantity) 
            }, { merge: true });
        } catch (err) {
            toast.error("Errore salvataggio carrello Firestore:", err, { autoClose: 5000 });
        }
    } else {
        dispatch({
            type: 'ADD_TO_BASKET',
            item: itemToAdd,
        });
    }

    toast.success(`${product.title} aggiunto!`);
  };

  if (!product) return <div>Caricamento...</div>;

  // Calcolo dinamico dell'immagine e del prezzo da mostrare nel component
  const currentImage = selectedVariant?.image || product.image;
  const currentPrice = selectedVariant?.price ?? product.price;

  return (
    <div className='productDetails'>
      {/* Ora l'immagine cambierà in base alla variante selezionata! *//*}
      <img src={currentImage} alt={product.title} className='productDetails_image' />

      <div className='productDetails_info'>
        <h2>{product.title}</h2>
        <p>{product.description}</p>

        {currentPrice && (
          <strong>{Number(currentPrice).toFixed(2)} €</strong>
        )}

        {product.variants && product.variants.length > 0 && (
          <div>
            <label>Seleziona misura:</label>
            <select
              value={selectedVariant?.size}
              onChange={(e) =>
                setSelectedVariant(
                  product.variants.find(v => v.size === e.target.value)
                )
              }
            >
              {product.variants.map((v, index) => (
                <option key={index} value={v.size}>
                  {v.size}
                </option>
              ))}
            </select>
          </div>
        )}

        <div>
          <label>Quantità:</label>
          <input
            type='number'
            value={quantity}
            min={1}
            onChange={(e) =>
              setQuantity(Math.max(1, parseInt(e.target.value) || 1))
            }
          />
        </div>

        <button onClick={addToBasket}>Aggiungi al carrello</button>
      </div>
    </div>
  );
}

export default ProductDetails;*/


import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc, setDoc, increment } from 'firebase/firestore';
import { db, auth } from './firebase';
import { useStateValue } from './StateProvider';
import './ProductDetails.css';
import { toast } from 'react-toastify';

function ProductDetails() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [, dispatch] = useStateValue();

  useEffect(() => {
    const fetchProduct = async () => {
      const docRef = doc(db, 'prodotti', id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = { id: docSnap.id, ...docSnap.data() };
        setProduct(data);

        if (data.variants && data.variants.length > 0) {
          setSelectedVariant(data.variants[0]);
        } else {
          setSelectedVariant(null);
        }

        setCurrentImageIndex(0);
      }
    };

    fetchProduct();
  }, [id]);

  /*
   * Se il prodotto ha il campo "images", utilizziamo quello.
   * Altrimenti utilizziamo la vecchia immagine "image".
   */
  const productImages =
    Array.isArray(product?.images) && product.images.length > 0
      ? product.images
      : product?.image
        ? [product.image]
        : [];

  /*
   * Se la variante ha una propria immagine,
   * viene mostrata quella.
   *
   * Altrimenti viene mostrata l'immagine del carosello.
   */
  const currentImage =
    selectedVariant?.image ||
    productImages[currentImageIndex];

  const currentPrice =
    selectedVariant?.price ?? product?.price;

  const addToBasket = async () => {
    if (
      Array.isArray(product.variants) &&
      product.variants.length > 0 &&
      !selectedVariant
    ) {
      alert("Seleziona una misura prima di aggiungere al carrello");
      return;
    }

    const finalID = selectedVariant
      ? selectedVariant.originalID
      : product.id;

    const finalSize = selectedVariant?.size ?? null;
    const finalPrice = Number(
      selectedVariant?.price ?? product.price
    );
    const finalPeso =
      selectedVariant?.peso ?? product.peso;

    const finalImage =
      selectedVariant?.image || product.image;

    const itemToAdd = {
      id: product.id,
      originalID: finalID,
      title: product.title,
      description: product.description,
      image: finalImage,
      price: finalPrice,
      quantity: Number(quantity) || 1,
      peso: finalPeso,
      size: finalSize
    };

    const user = auth.currentUser;
    const itemKey = `${finalID}_${finalSize}`;

    if (user) {
      const cartItemRef = doc(
        db,
        "users",
        user.uid,
        "carrello",
        itemKey
      );

      try {
        await setDoc(
          cartItemRef,
          {
            ...itemToAdd,
            quantity: increment(itemToAdd.quantity)
          },
          { merge: true }
        );
      } catch (err) {
        console.error(
          "Errore salvataggio carrello Firestore:",
          err
        );

        toast.error(
          "Errore durante il salvataggio nel carrello.",
          { autoClose: 5000 }
        );

        return;
      }
    } else {
      dispatch({
        type: 'ADD_TO_BASKET',
        item: itemToAdd
      });
    }

    toast.success(`${product.title} aggiunto!`);
  };

  /*
   * Immagine precedente
   */
  const previousImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0
        ? productImages.length - 1
        : prevIndex - 1
    );
  };

  /*
   * Immagine successiva
   */
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === productImages.length - 1
        ? 0
        : prevIndex + 1
    );
  };

  /*
   * Selezione diretta tramite pallino
   */
  const selectImage = (index) => {
    setCurrentImageIndex(index);
  };

  /*
   * Quando viene cambiata la variante,
   * torniamo alla prima immagine.
   */
  const handleVariantChange = (e) => {
    const variant = product.variants.find(
      (v) => v.size === e.target.value
    );

    setSelectedVariant(variant);
    setCurrentImageIndex(0);
  };

  if (!product) {
    return <div>Caricamento...</div>;
  }

  return (
    <div className='productDetails'>

      {/* CAROSELLO IMMAGINI */}
      <div className='productDetails_carousel'>

        <div className='productDetails_imageWrapper'>

          <img
            src={currentImage}
            alt={product.title}
            className='productDetails_image'
          />

          {/* Frecce: vengono mostrate solo se ci sono
              almeno 2 immagini */}
          {productImages.length > 1 && (
            <>
              <button
                className='productDetails_arrow productDetails_arrowLeft'
                onClick={previousImage}
                aria-label='Immagine precedente'
              >
                ‹
              </button>

              <button
                className='productDetails_arrow productDetails_arrowRight'
                onClick={nextImage}
                aria-label='Immagine successiva'
              >
                ›
              </button>
            </>
          )}

        </div>

        {/* Pallini */}
        {productImages.length > 1 && (
          <div className='productDetails_dots'>
            {productImages.map((_, index) => (
              <button
                key={index}
                className={`productDetails_dot ${
                  currentImageIndex === index
                    ? 'productDetails_dotActive'
                    : ''
                }`}
                onClick={() => selectImage(index)}
                aria-label={`Vai all'immagine ${index + 1}`}
              />
            ))}
          </div>
        )}

      </div>

      {/* INFORMAZIONI PRODOTTO */}
      <div className='productDetails_info'>

        <h2>{product.title}</h2>

        <p>{product.description}</p>

        {currentPrice && (
          <strong>
            {Number(currentPrice).toFixed(2)} €
          </strong>
        )}

        {product.variants &&
          product.variants.length > 0 && (
            <div>
              <label>Seleziona misura:</label>

              <select
                value={selectedVariant?.size || ''}
                onChange={handleVariantChange}
              >
                {product.variants.map((v, index) => (
                  <option
                    key={index}
                    value={v.size}
                  >
                    {v.size}
                  </option>
                ))}
              </select>
            </div>
          )}

        <div>
          <label>Quantità:</label>

          <input
            type='number'
            value={quantity}
            min={1}
            onChange={(e) =>
              setQuantity(
                Math.max(
                  1,
                  parseInt(e.target.value) || 1
                )
              )
            }
          />
        </div>

        <button onClick={addToBasket}>
          Aggiungi al carrello
        </button>

      </div>

    </div>
  );
}

export default ProductDetails;